angular.module("ainapp")
    .controller("productsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Add Product";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.ProductDesign = {};
            MainService.GetProductDesign().then(function (response) {
                $scope.ProductDesign = response.data;
            }, function (err) {})

            MainService.BrandsInDropdown().then(function (response) {
                $scope.Brands = response.data;
            });

            MainService.VATsInDropdown().then(function (response) {
                $scope.Vats = response.data;
            });

            MainService.UnitsInDropdown().then(function (response) {
                $scope.Units = response.data;
            });

            MainService.CountriesInDropdown().then(function (response) {
                $scope.Countries = response.data;
            });

            $scope.Categories = [];
            MainService.ProductsParentList("Product").then(function (response) {
                $scope.Categories = response.data;
            });

            $scope.Sizes = [];
            MainService.ProductSizesInDropdown().then(function (response) {
                $scope.Sizes = response.data;
            });

            $scope.Colors = [];
            MainService.ProductColorsInDropdown().then(function (response) {
                $scope.Colors = response.data;
            });

            $scope.Types = [];
            MainService.ProductTypesInDropdown().then(function (response) {
                $scope.Types = response.data;
            });

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                $scope.Branches = response.data;
            }, function (err) {
                toastr.error("Network Error");
            })


            $scope.GetSub = function () {
                $scope.Parents = [];
                MainService.ProductSubList($scope.CurrentTransProduct.CategoryId, "Product").then(function (response) {
                    $scope.Parents = response.data;
                });
            }

            $scope.branchSelectFun = function () {

                $scope.branchSelectDataSource = {
                    serverFiltering: true,
                    transport: {
                        read: function (o) {
                            o.success({
                                Data: $scope.Branches
                            });
                        }
                    },
                    schema: {
                        data: "Data"
                    },
                    pageSize: 10
                };

                $scope.selectBranchOptions = {
                    placeholder: "Select Branch...",
                    dataTextField: "Name",
                    dataValueField: "Id",
                    valuePrimitive: true,
                    autoBind: true,
                    dataSource: $scope.branchSelectDataSource
                };
            }

            $scope.VDesign = {};
            MainService.VoucherDesignsbyType("Product").then(function (response) {
                $scope.VDesign = response.data;
            });

            $scope.Init = function () {

                $scope.CurrentTransProduct = {
                    Name: "",
                    NameAr: "",
                    ProductCode: "",
                    ParentId: "",
                    IsActive: true,
                    IsGroup: true,
                    Level: 3,
                    ProductType: "Product",
                    BarCode: "",
                    Specification: "",
                    Model: "",
                    Description: "",
                    SupplierName: "",
                    DepreciationYear: "",
                    AMCCompany: "",
                    SellPrice: 0,
                    PurchasePrice: 0,
                    WarrantyDate: "",
                    UnitId: "",
                    CountryId: "",
                    manufacturing: "",
                    YRRefNo: "",
                    Stock: "",
                    VATId: "",
                    SalesAccountId: "",
                    PurchaseAccountId: "",
                    Image: "",
                    VatType: "Exclusive",
                    CategoryId: "",
                    BranchIds: [],
                    ProductSuppliers: [],
                }


                $scope.load = false;
                $scope.ViewVal = 0;

                $scope.selectedGroup = {};

                if ($stateParams.ItemId > 0) {
                    MainService.ProductById($stateParams.ItemId).then(function (response) {
                        $scope.CurrentTransProduct = response.data;

                        $scope.UOMList = $scope.CurrentTransProduct.UOMList;

                        $scope.CurrentTransProduct.BranchIds = [];
                        angular.forEach($scope.CurrentTransProduct.ProductBranchs, function (e) {
                            $scope.CurrentTransProduct.BranchIds.push(e.BranchId);
                        })

                        $scope.branchSelectFun();

                        $scope.GetSub();
                    }, function (err) {
                        $scope.load = false;
                        toastr.error("Network Error");
                    });

                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                    }, function (err) {});

                } else {
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                        $scope.CurrentTransProduct.VATId = $scope.CompanyProfile.DefaultVATId;
                        if ($scope.Categories != null && $scope.Categories.length > 0) {
                            $scope.CurrentTransProduct.CategoryId = $scope.Categories[0].Id;
                            $scope.GetSub();
                        }
                        $scope.CurrentTransProduct.UnitId = $scope.CompanyProfile.DefaultUnitId;
                    }, function (err) {});
                    $scope.branchSelectFun();
                }

            }
            $scope.Init();


            $scope.handleFileSelect = function (evt) {
                var file = evt.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (evt) {
                    $scope.$apply(function ($scope) {
                        $scope.myImage = evt.target.result;
                        $scope.CurrentTransProduct.Image = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };

            $scope.handleFileSelect2 = function (evt) {
                var file = evt.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (evt) {
                    $scope.$apply(function ($scope) {
                        $scope.myImage2 = evt.target.result;
                        $scope.CurrentProduct.Image = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };

            $scope.copyProduct = function () {
                if ($scope.CompanyProfile.IsProductRemarksCopy) {
                    $scope.CurrentTransProduct.Description = angular.copy($scope.CurrentTransProduct.Name);
                }
            }

            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.accountInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("Network Error");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.PurchaseAccountOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentTransProduct.PurchaseAccountId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.SalesAccountOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentTransProduct.SalesAccountId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.CogsAccountOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentTransProduct.COGSAccountId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.InventoryAccountOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentTransProduct.InventoryAccountId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };



            $scope.SuplierAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.SuppliersInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("Network Error");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.SupplierAccountOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentTransProduct.SupplierId = data.Id;
                    $scope.CurrentTransProduct.Supplier = data;
                    $scope.CurrentTransProduct.SupplierName = data.Name;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.SuplierAutocompleteDataSource
            };


            $scope.addTransProduct = function () {

                if ($scope.CurrentTransProduct.Name == "") {
                    toastr.warning("Give Name");
                } else if ($scope.CurrentTransProduct.ProductCode == "" && !$scope.CompanyProfile.IsAutoProductCode) {
                    toastr.warning("Give Code");
                } else if ($scope.CurrentTransProduct.VATId == "") {
                    toastr.warning("Select VAT");
                } else if ($scope.CurrentTransProduct.UnitId == "") {
                    toastr.warning("Select Unit");
                } else if ($scope.CurrentTransProduct.VATId == "") {
                    toastr.warning("Select Vat");
                } else {

                    $scope.CurrentTransProduct.ProductBranchs = [];
                    angular.forEach($scope.CurrentTransProduct.BranchIds, function (e) {
                        var tt = {
                            BranchId: e,
                        }
                        $scope.CurrentTransProduct.ProductBranchs.push(tt);
                    })

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    $scope.CurrentTransProduct.UOMList = $scope.UOMList;

                    MainService.AddProduct($scope.CurrentTransProduct).then(function (response) {
                        $scope.load = false;
                        if (response.data == "Success") {
                            toastr.success("Saved");
                            if ($scope.CurrentTransProduct.Id > 0) {
                                $state.go("productList");
                            }
                            $scope.Init();
                        } else {
                            toastr.error(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                    });
                }
            }




            $scope.GetStockLedger = function () {
                $scope.ViewVal = 50;
                $scope.StockLedger = [];

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.StockLedgerByProId($scope.CurrentTransProduct.Id).then(function (response) {
                    $scope.StockLedger = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });
            }

            $scope.UOMList = [];
            $scope.initUOM = function () {
                $scope.UnitConvertion = {
                    UnitId: "",
                    ConvertedUnitId: "",
                    Quantity: 0,
                    IsActive: true,
                }
            }

            $scope.initUOM();

            $scope.addUOMList = function () {
                if ($scope.UnitConvertion.UnitId == "") {
                    toastr.warning("Select Unit");
                } else if ($scope.UnitConvertion.ConvertedUnitId == "") {
                    toastr.warning("Select Converted Unit");
                } else if ($scope.UnitConvertion.Quantity <= 0) {
                    toastr.warning("Invalid Quantity");
                } else {
                    $scope.UOMList.push($scope.UnitConvertion);
                    $scope.initUOM();
                }
            }


            $scope.removeUOMRow = function (data) {
                data.IsActive = false;
            }


            $scope.initSupplier = function () {
                $scope.productSupplier = {
                    AccountMasterId: "",
                    AccountMaster: {},
                    Price: 0,
                }
            }
            $scope.initSupplier();

            $scope.SupplierAccountOptions2 = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.productSupplier.AccountMasterId = data.Id;
                    $scope.productSupplier.AccountMaster = data;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.SuplierAutocompleteDataSource
            };


            $scope.addSupplier = function () {
                if ($scope.UnitConvertion.AccountMasterId == "") {
                    toastr.warning("Select Supplier");
                } else {
                    $scope.CurrentTransProduct.ProductSuppliers.push($scope.productSupplier);
                    $scope.initSupplier();
                }
            }



            $scope.removeSupplierRow = function (data) {
                var index = $scope.CurrentTransProduct.ProductSuppliers.indexOf(data);
                $scope.CurrentTransProduct.ProductSuppliers.splice(index, 1);
            }



        }])
